module.exports = __webpack_public_path__ + "media/images/category/dummy/hat01-3e13407d6e0a3a85485825de8c6ed1e3.jpg";